<template>
  <div>
    <div id="loadingList" class="inactive fade">
      <h4>Yükleniyor...</h4>
      <p>(Deprem sıklığına bağlı gecikme olabilir.)</p>
    </div>
    <div class="containerList noselect">
      <div
        style="position: absolute; top: 0; width: 100%"
        class="flex-between"
      ></div>
      <div id="listLogo">
        <img draggable="false" :src="logo" alt="Sismik Harita Logo" />
        <a href="https://evrimagaci.org" target="_blank" id="byEA"
          >by Evrim Ağacı</a
        >
      </div>
      <!-- filtreleme -->
      <div class="glass filterContainer">
        <div class="flex-between align-center">
          <input
            id="filterSearchInput"
            type="search"
            placeholder="Ara"
            @input="searchDebounced($event)"
          />
          <div class="flex flex-row">
            <!-- <h5 class="filterBtn" id="filterMoreButton"
            @click="filterMoreToggle()">▼ Filtre
          </h5> -->
            <h5
              class="filterBtn"
              id="filterResetButton"
              @click="filter('filterResetButton')"
            >
              🔄️
            </h5>
            <h5
              class="filterBtn"
              id="filterSortButton"
              @click="filterSortMethod()"
            >
              ↕️
            </h5>
            <h5
              class="filterBtn"
              id="filterMagnitudeButton"
              @click="filterMagnitude()"
            >
              🔢
            </h5>
          </div>
        </div>

        <div
          v-if="values.recent && recencyPanel"
          @click="filterRecencyMethod($event)"
          id="moreFilterDateButtons"
        >
          <button class="filterBtn smallButton" id="filterDate-2s">2</button>
          <button class="filterBtn smallButton" id="filterDate-4s">4</button>
          <button class="filterBtn smallButton" id="filterDate-6s">6</button>
          <button class="filterBtn smallButton" id="filterDate-12s">12</button>
          <button class="filterBtn largeButton" id="filterDate-24s">
            24 Saat
          </button>
          <button class="filterBtn largeButton" id="filterDate-1h">
            1 Hafta
          </button>
        </div>

        <div v-show="magnitudePanel">
          <div id="filterMlRange">
            <h5>
              {{ `${filterMlRange[0]}-${filterMlRange[1]} Büyüklük` }}
            </h5>

            <Slider
              @change="this.applyRecencyFilter(0)"
              style="margin-top: 10px"
              class="modifySlider"
              v-model="filterMlRange"
              :merge="10"
              :min="0"
              :max="10"
              :options="{ margin: 1, steps: 0.1 }"
              :tooltips="false"
            />
          </div>
        </div>

        <div id="moreFilterWrapper" class="invisible">
          <div
            class="flex-row flex-between"
            style="width: 100%; height: fit-content"
          >
            <select
              @change="searchDebounced($event)"
              id="filterLocations"
              style="width: 35%"
            >
              <option value="" disabled selected>— Bölge...</option>
              <option v-for="location in this.values.locations" :key="location">
                {{ location }}
              </option>
            </select>
          </div>
          <!-- <div class="divider"></div> -->

          <!-- <div class="divider"></div> -->
          <!-- <div id="moreFilterDateButtons">
        <button @click="regionForGraph()" style="width:40%;" class="filterBtn largeButton"><i class="las la-object-ungroup"></i> Bölge seç</button>
        <button @click="toolTip.regionSelection = !toolTip.regionSelection; toolTip.chart = false">?</button>
        <button @click="loadGraph()" class="filterBtn largeButton"><i class="las la-project-diagram"></i> Grafik oluştur</button>
        <button @click="toolTip.chart = !toolTip.chart; toolTip.regionSelection = false">?</button>

      </div> -->
          <!-- <div class="divider"></div> -->
          <!-- <div class="tooltip">
        <p v-if="toolTip.regionSelection" style="margin:4px;">Grafik oluşturmak için bölge seçmek zorunlu değildir. Bölge seçilmediğinde, Türkiye ve çevresindeki depremler gösterilir.</p>
        <p v-if="toolTip.chart" style="margin:4px;">Tarih seçimi, büyüklük filtresi ve seçilen bölgeye göre grafik oluşturur.</p>
      </div> -->
        </div>
      </div>
      <!-- filtreleme -->
      <!-- :class="{'invisible': !filteredResults(quakes)}" -->
      <table :key="instance" id="quakesListElement">
        <tr
          @click="
            getMatchedMarker(
              quakes.id,
              quakes.body[0].enlem,
              quakes.body[0].boylam,
              $event
            )
          "
          class="qWrapper"
          v-for="quakes in this.displayedItems"
          :key="quakes.id"
          :style="{ 'background-color': colorize(quakes.body[0].buyukluk) }"
          style="display: block"
        >
          <div class="qInformation noevent">
            <h3 id="qLocationName">
              {{
                quakes.body[0].yer != ""
                  ? quakes.body[0].yer
                  : quakes.body[0].enlem + ", " + quakes.body[0].boylam
              }}
            </h3>
            <div id="qRecency">{{ dateToString(quakes.body[0].tarih) }}</div>
            <span id="qDate" style="display: none">{{
              quakes.body[0].tarih
            }}</span>
            <div id="qCoordinates" class="invisible">
              {{ quakes.body[0].enlem + ":" + quakes.body[0].boylam }}
            </div>
          </div>

          <div
            class="qGroupContainer noevent"
            :id="quakes.id"
            :data-quake="quakes.id"
          >
            <div class="noevent" v-for="quake in quakes.body" :key="quake.id">
              <td class="qSingleQuake flex-between align-center">
                <div style="width: 100%" class="flex-start flex-column">
                  <h5 id="qSingleQuakeDetails">
                    {{ quake.veriKaynagi }}
                  </h5>
                  <h5 id="qSingleQuakeLocation">
                    <span>
                      {{ displayHours(quake.tarih) }} | {{ quake.derinlik }} km
                      <text
                        v-if="
                          quake.nitelik?.includes('REVIZE') ||
                          quake.nitelik?.includes('reviewed')
                        "
                        style="color: red"
                        >{{ quake.nitelik }} |</text
                      ></span
                    >
                    {{ quake.adres }}
                  </h5>
                </div>
                <h3
                  id="qMagnitude"
                  :style="{
                    color:
                      quake.buyukluk >= 4
                        ? 'red'
                        : quake.buyukluk > 3
                        ? 'orange'
                        : 'black',
                  }"
                >
                  <!-- <span style="margin: 0; font-size: 14px;">{{ quake.yontem }}</span> -->
                  {{
                    String(quake.buyukluk).includes(".")
                      ? String(quake.buyukluk).replace(".", ",")
                      : quake.buyukluk + ",0"
                  }}
                </h3>
              </td>
            </div>
          </div>
        </tr>
      </table>
      <div id="endOfList" ref="endOfList"></div>

      <button id="goUpButton" class="inactive fade" @click="goUp()">
        <i class="las la-angle-up"></i>
      </button>
    </div>
  </div>
</template>

<script>
// console.log('QuakeList.vue');
import Slider from "@vueform/slider";
import "@vueform/slider/themes/default.css";

import _logo from "@/assets/logo.svg";
import debounce from "lodash/debounce";

const queryString = window.location.search;
const params = new URLSearchParams(queryString);

export default {
  components: {
    Slider,
  },
  emits: ["emitFly", "emitFilterMap", "emitGraph"],
  props: {
    quakes: Object,
    values: Object,
    loaded: Boolean,
    selectedDate: String,
    instance: Number,
    graphBoundaries: Object,
  },
  data() {
    return {
      logo: _logo,
      filtered: false,
      filterLocation: "",
      filterMlRange: [this.minMl, 10],
      filterMl: null,
      filterMaxMl: null,
      filteredRecency: "1h",
      recencyPanel: false,
      magnitudePanel: false,
      sortedData: this.quakes,
      sortedbyASC: true,
      displaying: [],
      dateString: [
        [31536000, "yıl"],
        [2419200, "ay"],
        [604800, "hafta"],
        [86400, "gün"],
        [3600, "saat"],
        [60, "dakika"],
        [1, "saniye"],
      ],
      lastChosenQuake: undefined,
      currentPage: 1,
      pageSize: 100,
      isLoading: false,
      toolTip: {
        regionSelection: false,
        chart: false,
      },
    };
  },
  methods: {
    // loadGraph() {
    //   const dateSelectionBox = document.querySelector('#filterDateSelectionBox')
    //   const theDate = dateSelectionBox.options[dateSelectionBox.selectedIndex].getAttribute('data-date');

    //   this.$emit("emitGraph", theDate, this.filterMlRange[0], this.filterMlRange[1], this.graphBoundaries);
    // },
    // regionForGraph() {
    //   document.querySelector('#sidebar').classList.remove('show')
    //   document.querySelector('.leaflet-draw-draw-rectangle').click()
    // },
    filteredResults(el) {
      this.filterMl = this.filterMlRange[0];
      this.filterMaxMl = this.filterMlRange[1];

      let singleQuakeElement = document.querySelector(
        `[data-quake="${el.id}"]`
      )?.parentElement;
      // let alternateLocation = el.adres

      if (this.filterLocation !== "") {
        // if (!el.yer.localeCompare(this.filterLocation, 'tr', { sensitivity: 'base' }) === 0) return false;
        if (
          !singleQuakeElement
            .querySelector("#qLocationName")
            .textContent.includes(this.filterLocation)
        )
          return false;

        if (this.filterMl !== null) {
          if (el.body[0].ml < this.filterMl) return false;
          else if (
            this.filterMaxMl !== null &&
            el.body[0].ml > this.filterMaxMl
          )
            return false;
          else {
            return true;
          }
        }

        if (this.filterMaxMl !== null) {
          if (el.body[0].ml > this.filterMaxMl) return false;
          else if (this.filterMl !== null && el.body[0].ml <= this.filterMl)
            return false;
          else {
            return true;
          }
        }
        return true;
      }

      if (this.filterMl !== null) {
        if (el.body[0].ml < this.filterMl) return false;
        else if (this.filterMaxMl !== null && el.body[0].ml > this.filterMaxMl)
          return false;
        else {
          return true;
        }
      }

      if (this.filterMaxMl !== null) {
        if (el.body[0].ml > this.filterMaxMl) return false;
        else if (this.filterMl !== null && el.body[0].ml <= this.filterMl)
          return false;
        else {
          return true;
        }
      }
      // }
      // else {
      // return true;
      // }
      // this.filtered && quakes[0].body[0].yer == this.filterLocation && quakes[0].body[0].buyukluk >= this.filterMl || quakes[0].body[0].yer == '' && quakes[0].body[0].buyukluk == 0
    },
    turkishToEnglish(str) {
      const trMap = {
        ç: "c",
        ğ: "g",
        ı: "i",
        ö: "o",
        ş: "s",
        ü: "u",
        Ç: "C",
        Ğ: "G",
        İ: "I",
        Ö: "O",
        Ş: "S",
        Ü: "U",
      };

      return str.replace(/[çğıöşüÇĞİÖŞÜ]/g, function (match) {
        return trMap[match];
      });
    },
    async filter(id) {
      // this.displaying = []
      const FILTERBY = id;
      const SELECTED =
        id !== "filterMl" ? document.querySelector("#" + id).value : false;

      const SEARCHED = document.querySelector("#filterSearchInput");

      if (FILTERBY === "filterResetButton") {
        SEARCHED.value = "";
        this.filtered = false;
        this.filterLocation = "";
        this.filterMlRange = [this.minMl, 10];
        this.filterMl = null;
        this.filterMaxMl = null;
        this.recencyPanel = false;
        document.querySelector("#filterLocations").selectedIndex = 0;
        document.querySelector("#filterSortButton").textContent = "↕️";

        // this.filterRecencyMethod(this.filteredRecency)

        this.sortedData = this.quakes;

        this.$nextTick(function () {
          this.quakes.forEach((el) => {
            this.displaying.push(el.id);
          });
          this.filterApplyOnMap(this.displaying);
        });

        return;
      }

      if (FILTERBY === "filterLocations") {
        this.filterLocation = SELECTED;
        return;
      }
    },
    async filterMoreToggle() {
      let moreFilterWrapper = document.querySelector("#moreFilterWrapper");
      moreFilterWrapper.classList.toggle("invisible");

      let moreFilterButton = document.querySelector("#filterMoreButton");
      moreFilterButton.textContent = moreFilterButton.textContent.includes(
        "▲ Filtre"
      )
        ? "▼ Filtre"
        : "▲ Filtre";
    },
    async filterMagnitudeMethod() {
      this.displaying = [];

      let atLeastOneHidden = false;
      this.$nextTick(function () {
        document.querySelectorAll(".qWrapper").forEach((quakeItem) => {
          quakeItem.style.display = "block";

          const mag = Number(
            quakeItem.querySelector("#qMagnitude").textContent.match(/\d+/)[0]
          );

          if (
            (this.filterMl != 0 && mag < this.filterMl) ||
            (this.filterMaxMl != 10 && mag >= this.filterMaxMl)
          ) {
            quakeItem.style.display = "none";
            atLeastOneHidden = true;
          } else {
            this.displaying.push(
              quakeItem
                .querySelector(".qGroupContainer")
                .getAttribute("data-quake")
            );
          }
        });
        if (atLeastOneHidden) {
          document.querySelector("#endOfList").style.position = "absolute";
          document.querySelector("#endOfList").style.bottom = "110vh";
        } else {
          document.querySelector("#endOfList").style.position = "unset";
          document.querySelector("#endOfList").style.bottom = "unset";
        }

        this.filterApplyOnMap(this.displaying);
      });
    },
    async filterSearchMethod($event) {
      const INPUT = this.turkishToEnglish($event.target.value.toLowerCase());

      this.$nextTick(async function () {
        this.displaying = [];

        document.querySelectorAll("#qLocationName").forEach((locTitle) => {
          const quakeItem = locTitle.parentElement.parentElement;
          quakeItem.style.display = "block";

          if (!quakeItem.innerHTML.toLowerCase().includes(INPUT)) {
            if (
              this.filterMl != 0 &&
              quakeItem.querySelector("#qMagnitude") < this.filterMl
            ) {
              quakeItem.style.display = "none";
            } else {
              quakeItem.style.display = "none";
            }
          } else {
            this.displaying.push(
              quakeItem
                .querySelector(".qGroupContainer")
                .getAttribute("data-quake")
            );
          }
        });

        this.filterApplyOnMap(this.displaying);
      });
    },
    searchDebounced: debounce(async function ($event) {
      this.filtered = true;

      this.$nextTick(async function () {
        if ($event.target.value === "") this.filter("filterResetButton");
        else await this.filterSearchMethod($event);
      });
    }, 200),
    async applyRecencyFilter(hours) {
      this.filtered = true;

      if (hours === 0) {
        this.fromDate = new Date(
          this.toDate.getTime() - 30 * 24 * 60 * 60 * 1000
        );
      } else {
        this.fromDate = new Date(new Date().getTime() - hours * 60 * 60 * 1000);
      }
      this.displaying = [];

      this.$nextTick(async function () {
        document.querySelectorAll(".qWrapper").forEach((el) => {
          el.style.display = "block";
          let theDate = new Date(el.querySelector("#qDate").textContent);

          if (
            theDate.getTime() >= this.fromDate.getTime() &&
            theDate.getTime() <= this.toDate.getTime()
          ) {
            this.displaying.push(
              el.querySelector(".qGroupContainer").getAttribute("data-quake")
            );
          } else {
            el.style.display = "none";
          }
        });
        this.filterApplyOnMap(this.displaying);
      });
    },
    filterRecencyMethod(event) {
      this.filtered = true;

      if (!event?.target?.id.includes("filterDate")) return;
      let SELECTED;
      try {
        SELECTED = event?.target?.id.split("-")[1];
      } catch {
        SELECTED = event;
      }

      this.filteredRecency = SELECTED;

      switch (SELECTED) {
        case "2s":
          this.applyRecencyFilter(2);
          break;
        case "4s":
          this.applyRecencyFilter(4);
          break;
        case "6s":
          this.applyRecencyFilter(6);
          break;
        case "12s":
          this.applyRecencyFilter(12);
          break;
        case "24s":
          this.applyRecencyFilter(24);
          break;
        case "1h":
          this.applyRecencyFilter(0);
          break;
        case "xy":
          document.querySelector("#datePickerFrom").removeAttribute("disabled");
          document.querySelector("#datePickerTo").removeAttribute("disabled");
          break;
      }
    },
    filterApplyOnMap(displaying) {
      if (this.displaying.length > 0) {
        this.$emit("emitFilterMap", displaying);
      }
    },
    filterMagnitude() {
      this.magnitudePanel = !this.magnitudePanel;
    },
    filterSortMethod() {
      this.recencyPanel = true;
      let tempArray2 = [...JSON.parse(JSON.stringify(this.quakes))];

      const filterSortButton = document.querySelector("#filterSortButton");

      if (this.sortedbyASC) {
        tempArray2.sort((x, y) =>
          x.body[0].buyukluk > y.body[0].buyukluk ? -1 : 1
        );
        this.sortedbyASC = false;
        filterSortButton.textContent = "🔽";
      } else {
        tempArray2.sort((x, y) =>
          x.body[0].buyukluk < y.body[0].buyukluk ? -1 : 1
        );
        this.sortedbyASC = true;
        filterSortButton.textContent = "🔼";
      }
      this.sortedData = Object.freeze(tempArray2);
      tempArray2 = [];
    },
    getMatchedMarker(_id, lat, lon, event) {
      let url = new URL(window.location.href);

      url.searchParams.set("lat", lat);
      url.searchParams.set("lon", lon);
      url.searchParams.set("id", _id);

      history.pushState(null, "", url.toString());

      if (window.innerWidth < 600) {
        document.querySelector("#sidebar").classList.remove("show");
      }

      const quakeId = _id;

      let target = event.target;

      if (!event.target.classList.contains("qWrapper")) {
        target = event.target.closest("qWrapper");
      }

      const allMarkers = document.querySelectorAll(".mapMarker");

      this.$emit("emitFly", lat, lon, _id, this.lastChosenQuake);

      this.lastChosenQuake =
        this.lastChosenQuake == quakeId
          ? (this.lastChosenQuake = null)
          : quakeId;

      if (event.target.classList.contains("highlight")) {
        allMarkers.forEach((marker) => {
          marker.classList.remove("invisible");
          marker.classList.remove("chosenQuake");
        });
        target.classList.remove("highlight");

        return;
      }
      document
        .querySelectorAll(".qWrapper")
        .forEach((el) =>
          el === target
            ? el.classList.add("highlight")
            : el.classList.remove("highlight")
        );
    },
    dateToString(date) {
      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };

      const today = new Date();
      today.setHours(0);
      today.setMinutes(0);
      today.setSeconds(0);
      today.setMilliseconds(0);
      let qRecencyEpochTime = new Date(date).getTime();

      if (
        new Date().toLocaleDateString("tr-TR", options) ==
        new Date(qRecencyEpochTime).toLocaleDateString("tr-TR", options)
      ) {
        const seconds = (new Date() - qRecencyEpochTime) / 1000;
        for (let [secondsPer, name] of this.dateString) {
          if (seconds >= secondsPer) {
            const amount = Math.floor(seconds / secondsPer);
            return `${amount} ${name} önce`;
          }
        }
        return "Şimdi";
      } else {
        return new Date(qRecencyEpochTime).toLocaleDateString("tr-TR", options);
      }
    },
    displayHours(date) {
      return date.split("T")[1];
    },
    padding(str) {
      return str.padEnd(10, " ");
    },
    colorize(quake) {
      return quake >= 4
        ? "rgba(250, 222, 223, .8)"
        : quake > 3
        ? "rgba(252, 237, 207, .8)"
        : "rgba(221, 227, 233, .8)";

      // return quake >= 4 ? 'rgba(250, 222, 223, 1)' : quake > 3 ? 'rgba(252, 237, 207, 1)' : 'rgba(241, 251, 224, 1)'
      // return quake > 4 ? 'rgba(255, 217, 218, .5)' : quake > 3 ? 'rgba(255, 243, 179, .5)' : 'rgba(212, 241, 244, .5)'
    },
    goUp() {
      const list = document.querySelector("#sidebar");
      list.scrollTop = 0;
    },

    async handleIntersection(entries) {
      if (entries[0].isIntersecting && !this.filtered) {
        await this.loadMore();
      }
    },
    async loadMore() {
      if (this.currentPage < this.pageCount && !this.isLoading) {
        this.isLoading = true;
        setTimeout(() => {
          const startIndex = this.currentPage * this.pageSize;
          const endIndex = startIndex + this.pageSize;
          const newItems = this.sortedData.slice(startIndex, endIndex);
          this.currentPage++;

          for (let i = 0; i < newItems.length; i++) {
            if (!this.sortedData.includes(newItems[i])) {
              this.sortedData.push(...newItems);
            }
          }
          this.isLoading = false;
        }, 250); // simulate a delay in loading more items
      }
      // this.filter('filterResetButton')
    },
  },
  created() {
    this.minMl = Number(this.values.minimumMl);
    this.filterMlRange = [this.minMl, 10];
  },
  async mounted() {
    this.observer = new IntersectionObserver(this.handleIntersection, {
      rootMargin: "0px",
      threshold: 1.0,
    });
    this.observer.observe(this.$refs.endOfList);
    // this.filter('filterResetButton')

    this.toDate = new Date();
    this.fromDate = new Date(
      this.toDate.getTime() -
        Number(this.values.daysBefore) * 24 * 60 * 60 * 1000
    );
    const list = document.querySelector("#sidebar");
    list.addEventListener("scroll", () => {
      const goUp = document.querySelector("#goUpButton");
      if (list.scrollTop > 100) {
        goUp.classList.remove("inactive");
      } else {
        goUp.classList.add("inactive");
      }
    });
  },
  unmounted() {
    this.observer.disconnect();
  },
  watch: {
    async filtered() {
      this.displayedItems;

      // this.$nextTick(async function() {
      //   await this.filter('filterResetButton')
      // });
    },
    filterMlRange() {
      this.filterMl = this.filterMlRange[0];
      this.filterMaxMl = this.filterMlRange[1];

      let url = new URL(window.location.href);
      url.searchParams.set("m", this.filterMl);
      history.pushState(null, "", url.toString());
      if (params.get("m") !== null) {
        this.minMl = Number(params.get("m"));
      }

      this.filterMagnitudeMethod();
      // this.$nextTick(() => {
      // })
    },
    // quakes(value) {
    //   this.sortedData = value
    //   this.$nextTick(async function() {
    //     await this.filter('filterResetButton')
    //   });
    //   // this.displayedItems().catch((err) => console.log(err));
    // }

    async instance() {
      this.$nextTick(async function () {
        await this.filter("filterResetButton");
      });
    },
  },
  computed: {
    pageCount() {
      return Math.ceil(this.sortedData.length / this.pageSize);
    },
    displayedItems() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;

      if (this.filtered) return this.sortedData;
      return [...new Set(this.sortedData.slice(0, endIndex))];
    },
  },
};
</script>

<style lang="scss" scoped>
span {
  margin-right: 5px;
}

input {
  padding-left: 0.5rem;
  line-height: 2rem;
  width: 40%;
  border: 0;
}

#goUpButton {
  position: sticky;
  bottom: 1%;
  left: 50%;
  transform: translateX(-47%);
  width: min-content;
  height: 50px;
  opacity: 0.8;
  font-size: 24px;

  border-radius: 5px;

  background-color: white;

  transition: border 200ms ease-in-out;
  border: 1px solid rgba($color: black, $alpha: 0.2);
  box-shadow: 0 0 10px rgba($color: #000000, $alpha: 0.3);
  &:hover {
    * {
      color: black;
    }
    cursor: pointer;
    border: 1px solid black;
  }
}

#loadingList {
  display: flex;
  position: sticky;
  top: 0;
  background-color: rgba($color: #fff, $alpha: 0.9);
  height: 100vh;
  width: 100%;
  text-align: center;
  justify-content: center;
  flex-direction: column;
  z-index: 99999;

  * {
    align-self: center;
    margin: 0;
  }
}

.filterContainer {
  margin: 0 2px;
  border-radius: 0.5rem;
  background-color: rgba($color: #fff, $alpha: 0.8) !important;
  border: 1px solid rgba($color: #fff, $alpha: 0.4);
  z-index: 10;

  position: relative;
  .filterBtn {
    font-size: 14px;

    @media only screen and (min-width: 2048px) {
      font-size: 20px;
    }
  }

  #filterSearchInput {
    z-index: 1;
    margin: 0;

    transition: all 100ms ease;
  }
}

#filterMlRange {
  border-radius: 0.5rem;
  background-color: rgba($color: #fff, $alpha: 0.9);
  padding: 1rem;
  margin-top: 2rem;
  h5,
  .modifySlider {
    color: black;
    text-align: center;
    font-size: large;
    font-weight: bolder;
    margin-top: 0;

    width: auto;

    @media only screen and (min-width: 2048px) {
      font-size: 28px;
    }
    @media only screen and (min-width: 3700px) {
      font-size: 36px;
    }
  }
  backdrop-filter: blur(3px) !important;

  @media only screen and (min-width: 600px) {
    padding-left: 30px;
    padding-right: 30px;
    margin: 10px;
    background: none;

    // background-color: rgba($color: #fff, $alpha: 0);
    // backdrop-filter: blur(0) !important;
    // background-color: rgba(222, 227, 232, 0.8) !important;

    h5,
    .modifySlider {
      color: black;
      text-align: center;
      font-size: normal;
      font-weight: bolder;
      margin-top: 0;

      width: 100%;
    }
  }
}

#moreFilterDateButtons {
  display: flex;
  width: 100%;
  height: 50%;
  justify-content: space-between;
  margin: 5px 0;
  flex-wrap: wrap;
}

.smallButton {
  margin: 0 2px;
  width: fit-content;
}

.largeButton {
  margin: 0 2px;
  flex: 1;
}
.filterBtn {
  text-align: center;
  display: inline-block;

  padding: 0.3rem 1rem;
  color: #575757;
  &:hover {
    color: black;
    cursor: pointer;
  }

  @media only screen and (min-width: 2048px) {
    font-size: large;
  }
}

table {
  border-spacing: 0;
}

.containerList {
  display: flex;
  flex-direction: column;
  position: relative;
  padding-top: 5%;

  background-color: rgba($color: #b2cee6, $alpha: 0.1);

  #quakesListElement {
    .qWrapper {
      // background-color: #b5bee2;

      // background-color: rgba($color: black, $alpha: 1);
      margin: 3px 1px;
      color: black;
      border-radius: 0.5rem;
      border: 1px solid rgba($color: #000000, $alpha: 0.4);
      background-color: rgba($color: #b2cee6, $alpha: 0.1);
      .qInformation {
        display: flex;
        align-items: center;
        align-content: center;
        justify-content: space-between;

        padding: clamp(0.2875rem, 0.2vw, 0.625rem);

        border-bottom: 1px dotted rgba($color: #000000, $alpha: 0.2);
        // background-color: rgba($color: white, $alpha: 0.5);
      }

      transition: all 10ms ease;
      &:hover {
        cursor: pointer;
        // #qRecency {
        //   opacity: 1;
        //   font-size: normal;
        // }
        // .qGroupContainer {
        //   background-color: rgba($color: white, $alpha: 0.5);
        // }

        filter: brightness(0.95);
        background: rgba($color: #000000, $alpha: 0.5);
      }
    }

    .qGroupContainer {
      font-size: 1.6vmin;
      padding: 0 clamp(0.1875rem, 0.2vw, 0.625rem);
      background-color: #fff;
      // padding-top: 0;
      // padding-bottom: 0;
      border-radius: 0 0 0.5rem 0.5rem;

      transition: all 1s ease;

      @media only screen and (max-width: 600px) {
        font-size: large !important;
      }
    }

    #qLocationName {
      font-weight: bold;
      border-radius: 0.5rem;
      background-color: rgba($color: black, $alpha: 1);
      color: white;

      font-size: clamp(0.5rem, 0.7rem, 1rem);
      line-height: clamp(1rem, 1.5vw, 1.5rem);
      // margin-top: 0.5rem;
      // margin-left: 0.5rem;
      padding: 0 0.5rem;

      border-radius: 0.5rem;
    }

    #qRecency {
      align-self: center;
      font-size: clamp(0.8rem, 1vw, 1rem);
      // font-size: clamp(0.7rem, 0.62vw, 2rem);
    }

    #qMagnitude {
      font-size: clamp(1.5rem, 1vw, 2rem);
    }

    .qSingleQuake {
      display: flex;
      justify-content: space-between;
      align-items: center;
      align-content: center;
      font-weight: lighter;
      border-bottom: 1px dotted rgba($color: #000000, $alpha: 0.2);
    }

    #qSingleQuakeDetails {
      font-size: clamp(0.8rem, 1vw, 1rem);
      // opacity: 0.6;

      // font-size: small;
    }
    #qSingleQuakeLocation {
      color: rgba($color: #000000, $alpha: 0.6);
      // font-size: clamp(0.8rem, 1.1vw, 1.1rem);
      font-size: clamp(0.5rem, 0.8vw, 0.8rem);

      // font-size: x-small;
      // line-height: clamp(1.2rem, 1.75vw, 1.75rem);
    }
  }

  #listLogo {
    display: flex;
    flex-direction: column;
    padding: 2rem 2rem;
    width: 100%;
    position: relative;
    justify-self: center;
    z-index: 4;

    img {
      align-self: center;
      margin: 0;
      margin-top: 2rem;
    }

    #byEA {
      position: absolute;
      width: max-content;
      left: 60%;
      top: 64%;
      color: black;
      z-index: 5;
      &:hover {
        text-decoration: underline;
      }
    }

    @media only screen and (min-width: 600px) {
      padding: 0 20px;
      margin: 0px;

      left: 50%;
      transform: translateX(-50%);
      width: 90%;
      padding: 0 !important;

      img {
        width: 80%;
        margin-top: 0;
        margin-bottom: 1rem;
      }
      // display: none;
      #byEA {
        left: 60%;
        top: 58%;
        font-size: clamp(8px, 0.7vw, 1rem);
        // display: none;
      }
    }
  }

  h3,
  h5 {
    margin: 0;
  }
}
</style>
